export const languageData = [
  {
    id: 1,
    language: 'English, US',
    value: 'en',
  },
  {
    id: 2,
    language: 'Korean',
    value: 'ko',
  },
  {
    id: 3,
    language: 'Chinese',
    value: 'zh',
  },
]
